import React, { Component } from 'react';
import { Button } from 'antd';
import { BackBtn } from '@comm/BackBtn';

class submitOp extends Component {
  constructor(props) {
    super(props);
    this.state = {};
  }

  render() {
    const { isSubmitting } = this.props;
    const dataItem = this.props.data;
    return (
      <div style={{ marginBottom: '16px' }}>
        <BackBtn />
        <Button
          icon="upload"
          type="primary"
          style={{ marginRight: 10 }}
          onClick={this.props.handSubmit}
          loading={isSubmitting}
        >
          发起申请
        </Button>
        {dataItem.uuid ? (
          <Button icon="delete" style={{ marginRight: 10 }} onClick={this.props.handleDelete}>
            删除
          </Button>
        ) : null}
      </div>
    );
  }
}

export default submitOp;



// WEBPACK FOOTER //
// ./src/components/finance/budget/set/submitOp.js